var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkPlayersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#180F24"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.85714,
    height: 2.85714,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 22.2627 29.0581)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.85714,
    height: 4.28571,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 20.834 30.4868)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.85714,
    height: 4.28571,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 32.2627 30.4868)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.85714,
    height: 4.28571,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 39.4053 26.2012)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.834,
    y: 26.2012,
    width: 2.85714,
    height: 4.28571,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 8.57143,
    height: 2.85714,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 29.4053 27.6294)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 5.71429,
    height: 2.85714,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 36.5479 23.3438)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6914,
    y: 23.3438,
    width: 5.71429,
    height: 2.85714,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2.85714,
    height: 2.85714,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 30.834 29.0581)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2.85714,
    height: 2.85714,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 37.9766 24.7725)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 12.2627,
    y: 24.7725,
    width: 2.85714,
    height: 2.85714,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2627,
    y: 20.4868,
    width: 2.85714,
    height: 2.85714,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4053,
    y: 16.2012,
    width: 2.85714,
    height: 2.85714,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 2.85714,
    height: 2.85714,
    transform: "matrix(-1 0 0 1 20.834 16.2012)",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 23.6914,
    y: 19.0581,
    width: 2.85714,
    height: 2.85714,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 30.834,
    y: 14.7725,
    width: 2.85714,
    height: 2.85714,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 2.85714,
    height: 2.85714,
    transform: "matrix(-1 0 0 1 19.4053 14.7725)",
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1201,
    y: 20.4868,
    width: 2.85714,
    height: 2.85714,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2627,
    y: 16.2012,
    width: 2.85714,
    height: 2.85714,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 2.85714,
    height: 2.85714,
    transform: "matrix(-1 0 0 1 17.9766 16.2012)",
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 23.6914,
    y: 21.9155,
    width: 2.85714,
    height: 2.85714,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 30.834,
    y: 17.6294,
    width: 2.85714,
    height: 2.85714,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 2.85714,
    height: 2.85714,
    transform: "matrix(-1 0 0 1 19.4053 17.6294)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkPlayersIcon);
export default __webpack_public_path__ + "static/media/dark-players-icon.4aac483b4aade36b400079565b53d981.svg";
export { ForwardRef as ReactComponent };